import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { ShevronDownIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronDownIcon'
import { ShevronUpIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronUpIcon'
import classNames from 'classnames'
import { Button } from '@/components/ui'
import { getUserGtmInfo } from '@/logic/metrika/helpers'
import { pushGtmEventOnExpand } from '@/pages/AdvancePaymentOnFutureHarvest/gtm-helpers'
import type { RootState } from '@/redux/interfaces'
import { LandingAnimation } from '../../../../components/composed/landingBlocks/LandingAnimation'
import { LANDING_ANIMATION } from '../../../../components/composed/landingBlocks/LandingAnimation/constants'
import { LandingLoanTerm } from './components/LandingLoanTerm'
import { ELandingLoanTermsAnimationDelay } from './constants'
import { messages } from './messages'
import type { TLandingLoanTermsProps } from './types'
import './styles.scss'

const mapState = (state: RootState) => ({
  userGtmInfo: getUserGtmInfo()(state),
})

export const LandingLoanTerms: React.FC<TLandingLoanTermsProps> = ({ className, title, termGroups, onExpaned }) => {
  const [groupOpenedMap, setGroupOpenedMap] = useState<Record<string, boolean>>({})

  const { userGtmInfo } = useSelector(mapState)
  const { userRegion } = useUserRegion()

  const handleClickCollapse = (groupTitle: string) => () => {
    if (!groupOpenedMap[groupTitle]) {
      onExpaned?.()
      pushGtmEventOnExpand(userGtmInfo, userRegion.name, groupTitle)
    }

    setGroupOpenedMap(map => ({
      ...map,
      [groupTitle]: !map[groupTitle],
    }))
  }

  return (
    <section className={classNames('landingLoanTerms', className)}>
      <div className="landingLoanTerms__wrapper page-wrapper">
        <LandingAnimation desktopTargetStyles={{ ...LANDING_ANIMATION.fadeUp, delay: ELandingLoanTermsAnimationDelay.TITLE }}>
          <h2>{title}</h2>
        </LandingAnimation>
        <LandingAnimation desktopTargetStyles={{ ...LANDING_ANIMATION.fadeUp, delay: ELandingLoanTermsAnimationDelay.LIST }}>
          <div className="landingLoanTerms__terms">
            {termGroups.map(group => (
              <div
                className={classNames('landingLoanTerms__group', {
                  'landingLoanTerms__group--opened': groupOpenedMap[group.title],
                })}
                key={group.title}
              >
                <div className={'landingLoanTerms__groupSpoiler'}>
                  <h3 className="h4">{group.title}</h3>
                  <Button
                    className="landingLoanTerms__groupSpoilerTrigger"
                    modifiers={['green']}
                    onClick={handleClickCollapse(group.title)}
                    iconPosition="right"
                    iconProps={{
                      component: groupOpenedMap[group.title] ? <ShevronUpIcon /> : <ShevronDownIcon />,
                    }}
                  >
                    {groupOpenedMap[group.title] ? messages.button.collapse : messages.button.open}
                  </Button>
                </div>
                {groupOpenedMap[group.title] && <LandingLoanTerm isOpen={groupOpenedMap[group.title] === true} group={group} />}
              </div>
            ))}
          </div>
        </LandingAnimation>
      </div>
    </section>
  )
}
